/**
 * Mobile menu.
 */

const menuToggle = document.querySelector('.site-menu-toggle');
const mobileNav = document.querySelector('.site-mobile-nav');
const mobileOverlay = document.querySelector('.site-mobile-overlay');
const closeTriggers = document.querySelectorAll('[data-mobile-menu-close]');
const header = document.querySelector('.site-header');
const rootMenuEntries = mobileNav?.querySelectorAll('.site-mobile-nav__menu > .menu-item') || [];
const rootMenuItems = mobileNav?.querySelectorAll('.site-mobile-nav__menu > .menu-item-has-children') || [];
const menuVisual = mobileNav?.querySelector('.site-mobile-nav__feature-image');
let lastFocusedElement = null;
let bodyPaddingRight = '';
let headerPaddingRight = '';
let rootHoverTimeout = null;

function initMenuProjectsSlider() {
  const slider = mobileNav?.querySelector('[data-menu-projects-slider]');
  const slides = slider ? Array.from(slider.querySelectorAll('[data-menu-project-slide]')) : [];

  if (!slider || slides.length === 0) {
    return;
  }

  const previousButton = slider.querySelector('[data-menu-projects-prev]');
  const nextButton = slider.querySelector('[data-menu-projects-next]');
  const track = slider.querySelector('.site-mobile-nav__projects-track');
  let activeIndex = 0;
  let intervalId = null;
  let isAnimating = false;

  const stackStates = [
    { offsetIndex: 0, y: 0, scale: 1, opacity: 1, zIndex: 3 },
    { offsetIndex: 1, y: 0, scale: 1, opacity: 0.92, zIndex: 2 },
    { offsetIndex: 2, y: 0, scale: 1, opacity: 0.78, zIndex: 1 },
  ];

  const getOrderedSlides = () => (
    slides.map((_, offset) => slides[(activeIndex + offset) % slides.length])
  );

  const applyStack = (animate = true) => {
    const orderedSlides = getOrderedSlides();

    orderedSlides.forEach((slide, stackIndex) => {
      const state = stackStates[Math.min(stackIndex, stackStates.length - 1)];

      slide.hidden = false;
      slide.classList.toggle('is-active', stackIndex === 0);
      slide.style.position = 'absolute';
      slide.style.inset = '0';
      slide.style.left = `calc(var(--menu-project-slide-offset) * ${state.offsetIndex})`;
      slide.style.zIndex = String(state.zIndex - Math.max(0, stackIndex - 2));
      slide.style.opacity = String(stackIndex > 2 ? 0 : state.opacity);
      slide.style.pointerEvents = stackIndex === 0 ? 'auto' : 'none';
      slide.style.transform = `translate3d(0, ${state.y}px, 0) scale(${state.scale})`;
      slide.style.transformOrigin = 'center center';

      if (animate) {
        slide.style.transition = 'left 460ms cubic-bezier(.22,.61,.36,1), transform 460ms cubic-bezier(.22,.61,.36,1), opacity 360ms ease';
      } else {
        slide.style.transition = 'none';
      }
    });

    if (track) {
      track.style.position = 'relative';
    }
  };

  const stopAutoplay = () => {
    if (intervalId) {
      window.clearInterval(intervalId);
      intervalId = null;
    }
  };

  const startAutoplay = () => {
    if (slides.length <= 1) {
      return;
    }

    stopAutoplay();
    intervalId = window.setInterval(() => {
      shuffleNext();
    }, 4200);
  };

  const shuffleNext = () => {
    if (isAnimating || slides.length <= 1) {
      return;
    }

    isAnimating = true;
    stopAutoplay();

    const currentSlide = slides[activeIndex];

    currentSlide.style.transition = 'transform 320ms cubic-bezier(.4,0,.2,1), opacity 260ms ease';
    currentSlide.style.transform = 'translate3d(-115%, -8px, 0) rotate(-3deg) scale(.98)';
    currentSlide.style.opacity = '0';

    window.setTimeout(() => {
      activeIndex = (activeIndex + 1) % slides.length;
      applyStack(true);

      window.setTimeout(() => {
        isAnimating = false;
        startAutoplay();
      }, 470);
    }, 320);
  };

  const shufflePrevious = () => {
    if (isAnimating || slides.length <= 1) {
      return;
    }

    isAnimating = true;
    stopAutoplay();

    activeIndex = (activeIndex - 1 + slides.length) % slides.length;
    const incomingSlide = slides[activeIndex];

    incomingSlide.hidden = false;
    incomingSlide.style.position = 'absolute';
    incomingSlide.style.inset = '0';
    incomingSlide.style.zIndex = '4';
    incomingSlide.style.pointerEvents = 'none';
    incomingSlide.style.transition = 'none';
    incomingSlide.style.opacity = '0';
    incomingSlide.style.transform = 'translate3d(-115%, -8px, 0) rotate(-3deg) scale(.98)';

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        incomingSlide.style.transition = 'transform 420ms cubic-bezier(.22,.61,.36,1), opacity 300ms ease';
        incomingSlide.style.opacity = '1';
        incomingSlide.style.transform = 'translate3d(0, 0, 0) scale(1)';

        window.setTimeout(() => {
          applyStack(true);
          isAnimating = false;
          startAutoplay();
        }, 430);
      });
    });
  };

  previousButton?.addEventListener('click', shufflePrevious);
  nextButton?.addEventListener('click', shuffleNext);

  slider.addEventListener('mouseenter', stopAutoplay);
  slider.addEventListener('mouseleave', startAutoplay);
  slider.addEventListener('focusin', stopAutoplay);
  slider.addEventListener('focusout', startAutoplay);

  applyStack(false);

  requestAnimationFrame(() => {
    slides.forEach(slide => {
      slide.style.transition = '';
    });
    applyStack(true);
  });

  startAutoplay();
}

function syncMenuDepthState() {
  const secondPanelIsOpen = Boolean(
    mobileNav?.querySelector('.site-mobile-nav__menu > .menu-item.is-mega-active > .sub-menu')
  );

  mobileNav?.classList.toggle('is-second-panel-open', secondPanelIsOpen);
}

function hasMenuVisual(item) {
  return Boolean(item?.querySelector(':scope > a')?.dataset.menuImage);
}
/**
 * Image principale du megamenu.
 *
 * Change l'image puis lance le reveal
 * seulement quand la nouvelle image est chargée.
 */
function showMenuVisual(item) {
  if (!window.matchMedia('(hover: hover)').matches || !menuVisual || !window.gsap) {
    return;
  }

  const itemImage = item?.querySelector(':scope > a')?.dataset.menuImage;
  const shouldDarkenImage = item?.querySelector(':scope > a')?.dataset.menuFilter === 'dark';
  const imageSource = itemImage || menuVisual.dataset.src;

  if (!imageSource) {
    return;
  }

  const animateVisual = () => {
    mobileNav?.classList.add('is-visual-active');
    menuVisual.classList.toggle('is-filtered', shouldDarkenImage);

    window.gsap.killTweensOf(menuVisual);

    window.gsap.fromTo(
      menuVisual,
      {
        clipPath: 'inset(0 100% 0 0)',
        opacity: 1,
      },
      {
        clipPath: 'inset(0 0 0 0)',
        opacity: 1,
        duration: 0.55,
        ease: 'power3.out',
      }
    );
  };

  if (menuVisual.getAttribute('src') === imageSource) {
    animateVisual();
    return;
  }

  const preloadImage = new Image();

  preloadImage.onload = () => {
    menuVisual.setAttribute('src', imageSource);
    animateVisual();
  };

  preloadImage.src = imageSource;
}

function hideMenuVisual() {
  mobileNav?.classList.remove('is-visual-active');

  if (menuVisual) {
    menuVisual.classList.remove('is-filtered');
    window.gsap?.killTweensOf(menuVisual);
    menuVisual.style.opacity = '0';
    menuVisual.style.clipPath = 'inset(0 100% 0 0)';
  }
}

function showDefaultMenuVisual() {
  if (!mobileNav || !menuVisual || !menuVisual.dataset.src) {
    return;
  }

  window.gsap?.killTweensOf(menuVisual);
  menuVisual.setAttribute('src', menuVisual.dataset.src);
  menuVisual.classList.remove('is-filtered');
  menuVisual.style.opacity = '1';
  menuVisual.style.clipPath = 'inset(0 0 0 0)';
  mobileNav.classList.add('is-visual-active');
}

function resetMobileMenuState() {
  if (!mobileNav) {
    return;
  }

  clearRootHoverTimeout();
  mobileNav.classList.remove('is-second-panel-open', 'is-visual-active');
  mobileNav.querySelectorAll('.is-mega-active, .is-mega-entering').forEach(item => {
    item.classList.remove('is-mega-active', 'is-mega-entering');
  });
  mobileNav.querySelectorAll('.service-nav-item.is-active').forEach(item => {
    item.classList.remove('is-active');
  });
}

function lockPageScroll() {
  const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;

  bodyPaddingRight = document.body.style.paddingRight;
  headerPaddingRight = header?.style.paddingRight || '';

  if (scrollbarWidth > 0) {
    const currentBodyPadding = parseFloat(window.getComputedStyle(document.body).paddingRight) || 0;
    const currentHeaderPadding = header
      ? parseFloat(window.getComputedStyle(header).paddingRight) || 0
      : 0;

    document.body.style.paddingRight = `${currentBodyPadding + scrollbarWidth}px`;

    if (header) {
      header.style.paddingRight = `${currentHeaderPadding + scrollbarWidth}px`;
    }
  }

  document.body.classList.add('overflow-hidden');
}

function unlockPageScroll() {
  document.body.classList.remove('overflow-hidden');
  document.body.style.paddingRight = bodyPaddingRight;

  if (header) {
    header.style.paddingRight = headerPaddingRight;
  }

}

function activateMenuItem(item) {
  if (!item) {
    return;
  }

  const siblings = item.parentElement?.children || [];
  const submenu = item.querySelector(':scope > .sub-menu');

  Array.from(siblings).forEach(sibling => {
    sibling.classList.remove('is-mega-active');
    sibling.querySelector(':scope > .service-nav-item')?.classList.remove('is-active');
  });

  item.classList.remove('is-mega-entering');
  item.classList.add('is-mega-active');
  item.querySelector(':scope > .service-nav-item')?.classList.add('is-active');

  if (item.parentElement?.classList.contains('site-mobile-nav__menu')) {
    if (submenu) {
      const firstVisualLink = submenu.querySelector(':scope > .menu-item > a[data-menu-image]');
      const firstVisualItem = firstVisualLink?.parentElement;

      if (firstVisualItem) {
        showMenuVisual(firstVisualItem);
      } else {
        hideMenuVisual();
      }
    }

    item.querySelectorAll(':scope > .sub-menu > .menu-item-has-children').forEach(childItem => {
      childItem.classList.remove('is-mega-active', 'is-mega-entering');
      childItem.querySelector(':scope > .service-nav-item')?.classList.remove('is-active');
    });
  }

  if (submenu) {
    const firstMenuItem = item.parentElement?.firstElementChild;
    const submenuOffset = firstMenuItem
      ? firstMenuItem.getBoundingClientRect().top - item.getBoundingClientRect().top
      : 0;

    submenu.style.setProperty('--submenu-offset', `${submenuOffset}px`);
  }

  requestAnimationFrame(() => {
    item.classList.add('is-mega-entering');
  });

  syncMenuDepthState();
}

function clearRootHoverTimeout() {
  if (!rootHoverTimeout) {
    return;
  }

  window.clearTimeout(rootHoverTimeout);
  rootHoverTimeout = null;
}

function scheduleRootMenuActivation(item) {
  if (!window.matchMedia('(hover: hover)').matches) {
    return;
  }

  clearRootHoverTimeout();

  if (!mobileNav?.querySelector('.site-mobile-nav__menu > .menu-item.is-mega-active')) {
    activateMenuItem(item);
    return;
  }

  rootHoverTimeout = window.setTimeout(() => {
    activateMenuItem(item);
    rootHoverTimeout = null;
  }, 140);
}

rootMenuItems.forEach(item => {
  const trigger = item.querySelector(':scope > a');

  trigger?.addEventListener('click', event => {
    if (!window.matchMedia('(hover: hover)').matches) {
      event.preventDefault();

      if (!item.classList.contains('is-mega-active')) {
        activateMenuItem(item);
      }

      return;
    }

    if (!item.classList.contains('is-mega-active')) {
      event.preventDefault();
      clearRootHoverTimeout();
      activateMenuItem(item);
    }
  });

  item.addEventListener('mouseenter', () => {
    scheduleRootMenuActivation(item);
  });

});

mobileNav?.querySelectorAll('.sub-menu > .menu-item').forEach(childItem => {
  const childTrigger = childItem.querySelector(':scope > a');

  if (childItem.classList.contains('menu-item-has-children')) {
    childTrigger?.addEventListener('click', event => {
      if (window.matchMedia('(hover: hover)').matches) {
        event.preventDefault();
        return;
      }

      event.preventDefault();

      if (!childItem.classList.contains('is-mega-active')) {
        activateMenuItem(childItem);
      }
    });

  }

  childItem.addEventListener('mouseenter', () => {
    if (window.matchMedia('(hover: hover)').matches) {
      clearRootHoverTimeout();
      activateMenuItem(childItem);

      if (hasMenuVisual(childItem)) {
        showMenuVisual(childItem);
      }
    }
  });

  childTrigger?.addEventListener('focus', () => {
    activateMenuItem(childItem);

    if (hasMenuVisual(childItem)) {
      showMenuVisual(childItem);
    }
  });
});

rootMenuEntries.forEach(item => {
  if (item.classList.contains('menu-item-has-children')) {
    return;
  }

  item.addEventListener('mouseenter', () => {
    if (!window.matchMedia('(hover: hover)').matches) {
      return;
    }

    rootMenuItems.forEach(rootItem => {
      rootItem.classList.remove('is-mega-active', 'is-mega-entering');
    });

    if (item.querySelector(':scope > a')?.dataset.menuImage) {
      mobileNav?.classList.remove('is-visual-active');

      requestAnimationFrame(() => {
        showMenuVisual(item);
      });
    } else {
      hideMenuVisual();
    }

    syncMenuDepthState();
  });
});

function openMobileMenu() {
  if (!menuToggle || !mobileNav) {
    return;
  }

  lastFocusedElement = document.activeElement;
  menuToggle.classList.add('is-active');
  menuToggle.setAttribute('aria-expanded', 'true');

  mobileNav.classList.toggle('is-header-sticky', header?.classList.contains('is-sticky'));
  mobileNav.classList.add('is-open');
  mobileNav.classList.add('is-visual-active');
  mobileNav.setAttribute('aria-hidden', 'false');
  header?.classList.add('is-menu-open');

  mobileOverlay?.classList.add('is-visible');

  lockPageScroll();
  resetMobileMenuState();
  showDefaultMenuVisual();
  menuToggle.focus();
}

function closeMobileMenu() {
  if (!menuToggle || !mobileNav) {
    return;
  }

  menuToggle.classList.remove('is-active');
  menuToggle.setAttribute('aria-expanded', 'false');

  mobileNav.classList.remove('is-open');
  mobileNav.setAttribute('aria-hidden', 'true');
  resetMobileMenuState();
  header?.classList.remove('is-menu-open');

  mobileOverlay?.classList.remove('is-visible');

  unlockPageScroll();

  if (lastFocusedElement instanceof HTMLElement) {
    lastFocusedElement.focus();
  }
}

function toggleMobileMenu() {
  if (mobileNav?.classList.contains('is-open')) {
    closeMobileMenu();
    return;
  }

  openMobileMenu();
}

menuToggle?.addEventListener('click', event => {
  event.preventDefault();
  toggleMobileMenu();
});

closeTriggers.forEach(trigger => {
  trigger.addEventListener('click', event => {
    event.preventDefault();
    closeMobileMenu();
  });
});

mobileNav?.querySelectorAll('a').forEach(link => {
  link.addEventListener('click', () => {
    if (link.classList.contains('js-menu-anchor-close')) {
      closeMobileMenu();
      return;
    }

    if (link.parentElement?.classList.contains('menu-item-has-children')) {
      return;
    }

    closeMobileMenu();
  });
});

document.addEventListener('keydown', event => {
  if (event.key === 'Escape' || event.key === 'Esc' || event.keyCode === 27) {
    // Patch temporaire: garder le menu ouvert tant que le X n'est pas pese.
    // closeMobileMenu();
  }
});

window.addEventListener('resize', () => {
  if (window.innerWidth >= 1025) {
    // Patch temporaire: garder le menu ouvert au resize tant que le X n'est pas pese.
    // closeMobileMenu();
  }
});

initMenuProjectsSlider();
